import { settings } from '@/api/config';
import axios from 'axios';
import { getInitData } from '@/utils/getInitData';

export const getTasksCompleted = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/users/tasks/completed?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении задач:', error);
    throw error;
  }
};
